export const colors = {
  // Основные цвета
  primary: {
    main: '#6C63FF',
    light: '#8A70D6',
    dark: '#5A52D5',
  },
  secondary: {
    main: '#00C6FF',
    light: '#33D1FF',
    dark: '#0099CC',
  },
  
  // Фоновые цвета
  background: {
    default: '#F4F7FE',
    paper: '#FFFFFF',
  },
  
  // Текстовые цвета
  text: {
    primary: '#1F2C45',
    secondary: '#697386',
  },
  
  // Цвета для карточек
  cards: {
    topic: '#FFF3FC',
    audio: '#E9F5FF',
    course: '#F0EFFD',
  },
  
  // Градиенты
  gradients: {
    emotionalState: 'linear-gradient(135deg, #7F7FD5 0%, #86A8E7 50%, #91EAE4 100%)',
    emotionalStateHover: 'linear-gradient(135deg, #6C63FF, #00C6FF)',
    chat: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  },
  
  // Тени
  shadows: {
    card: '0 10px 30px rgba(0, 0, 0, 0.08)',
    button: '0 4px 15px rgba(108, 99, 255, 0.3)',
    buttonHover: '0 8px 25px rgba(108, 99, 255, 0.4)',
    search: '0 4px 12px rgba(0, 0, 0, 0.05)',
    searchHover: '0 6px 20px rgba(108, 99, 255, 0.1)',
    searchFocus: '0 8px 25px rgba(108, 99, 255, 0.15)',
  },
} as const; 